import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokProductBanner } from "@/storyblok";
import { type BlokProps, StoryblokComponentList } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import { AssetBlok, sizes } from "../Asset";
import { MediaLink } from "../MediaLink";
import styles from "./ProductBanner.module.css";
import type { BaseSBType } from "@/types/storyblok-compat";

export const ProductBannerBlok = ({ blok, preview, index = 0 }: BlokProps<BlokProductBanner>) => {
	return (
		<BlokWrap data-animate editable={blok} asChild>
			<div className={styles.content}>
				<div data-fade className={clsx(styles.side)}>
					{blok.leftAsset && (
						<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
							<AssetBlok source={blok.leftAsset} sizes={sizes(100, 50)} />
						</MediaLink>
					)}
				</div>
				<div data-fade className={clsx(styles.side)}>
					{blok.right && (
						<StoryblokComponentList bloks={blok.right as BaseSBType[]} preview={preview} />
					)}
				</div>
			</div>
		</BlokWrap>
	);
};
